export const ArrowButtonHome = () => (
    <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Arrow Button Home">
        <path d="M10.5087 4.375H0V2.625H10.5087V0L14 3.5L10.5087 7V4.375Z" fill="currentColor" />
    </svg>
);
